import createReactComponent from '../createReactComponent';
export default createReactComponent('female', 'Female', [["path",{"d":"M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 0v6m-2-2h4","key":"svg-0"}]]);